import { Dropdown, DropDownProps } from "antd";
import React from "react";
import styles from "./index.module.css";
import checked from "assets/svg/Checked.svg";

interface CustomDropdownProps extends DropDownProps {
  children: React.ReactElement; // важно! НЕ ReactNode
}

export const CustomDropdown = ({ children, menu, ...restProps }: CustomDropdownProps) => {
  return (
    <Dropdown
      {...restProps}
      placement="bottomLeft"
      openClassName={styles.wrapper}
      menu={{
        ...menu,
        items: menu?.items?.map((item) => ({
          ...item,
          extra: item.key === menu.selectedKeys[0] ? <img src={checked} alt="check" /> : undefined,
        })),
        className: styles.wrapperPopUp,
      }}
    >
      {children}
    </Dropdown>
  );
};
